import { init, RematchRootState, Models, ModelConfig, ModelEffects } from '@rematch/core'
import storage from 'redux-persist/lib/storage'
import * as models from '-/models'
import createLoadingPlugin from '@rematch/loading'
import createRematchPersist from '@rematch/persist'

// Options 设置请参考
// https://github.com/rematch/rematch/blob/master/plugins/loading/README.md#options
const loadingPlugin = createLoadingPlugin({})

const persistPlugin = createRematchPersist({
  key: 'root',
  whitelist: ['account'],
  throttle: 2000,
  version: 1,
  storage,
})

const store = init({
  models,
  plugins: [loadingPlugin, persistPlugin],
})

/* eslint-disable @typescript-eslint/no-explicit-any */
export type ExtractRematchLoadingFromEffects<
  effects extends ModelConfig['effects']
> = effects extends (...args: any[]) => infer R
  ? R extends ModelEffects<any>
    ? ExtractRematchLoadingFromEffectsObject<R>
    : {}
  : effects extends ModelEffects<any>
  ? ExtractRematchLoadingFromEffectsObject<effects>
  : {}

export type ExtractRematchLoadingFromEffectsObject<effects extends ModelEffects<any>> = {
  [effectKey in keyof effects]: boolean
}
/* eslint-enable @typescript-eslint/no-explicit-any */

interface LoadingPlugin<M extends Models> {
  loading: {
    global: boolean
    models: { [K in keyof M]: boolean }
    effects: { [K in keyof M]: ExtractRematchLoadingFromEffects<M[K]['effects']> }
  }
}

export type Store = typeof store
export type Dispatch = typeof store.dispatch
export type RootState = RematchRootState<typeof models> & LoadingPlugin<typeof models>

export default store
